import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=01792f98&scoped=true"
import script from "./Welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./Welcome.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=01792f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01792f98",
  null
  
)

export default component.exports